import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {surveyPreset, surveys,survey,surveyCopy,surveyAnswers,
    surveyAnswer,surveyStatistic,surveyContentStatistic,surveyExport,
    votes,vote,voteTitle,votesAnswers,votesCaptcha,votesAnswerName,
    votesStatistic,votesStatisticId,votesExport,votesCopy,surveyEmptyAnswer,votesEmptyAnswer,votesEmpty,
    adminSurveys, adminVotes, surveyRecover} = api

/**
 * 查找列表
 */
export async function findSurveys(params) {
    return request({url: surveys, method: 'get', data: params,})
}
/**
 * 管理员查找列表
 */
export async function findAdminSurveys(params) {
    return request({url: adminSurveys, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function findSurvey(params) {
    return request({url: survey, method: 'get', data: params,})
}
/**
 * 复制
 */
export async function findSurveyCopy(params) {
    return request({url: surveyCopy, method: 'get', data: params,})
}
/**
 * 简单修改
 */
export async function updateSurvey(params) {
    return request({url: survey, method: 'put', data: params,})
}

export async function recover(params) {
    return request({url: surveyRecover, method: 'get', data: params,})
}
/**
 * 查找预置项
 */
export async function findSurveyPreset(params) {
    return request({url: surveyPreset, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createSurvey(params) {
    return request({url: surveys, method: 'post', data: params,})
}
/**
 * 提交答案
 */
export async function submitSurveyAnswer(params) {
    return request({url: surveyAnswers, method: 'post', data: params,})
}
/**
 * 查询答案
 */
export async function findSurveyAnswers(params) {
    return request({url: surveyAnswers, method: 'get', data: params,})
}

/**
 * 查询答案详情
 */
export async function findSurveyAnswer(params) {
    return request({url: surveyAnswer, method: 'get', data: params,})
}
/**
 * 删除答案详情
 */
export async function deleteSurveyAnswer(params) {
    return request({url: surveyAnswer, method: 'delete', data: params,})
}
/**
 * 查询统计列表
 */
export async function findSurveyStatistic(params) {
    return request({url: surveyStatistic, method: 'get', data: params,})
}
/**
 * 查询统计文本列表
 */
export async function findSurveyContentStatistic(params) {
    return request({url: surveyContentStatistic, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function exportSurvey(params) {
    return request({url: surveyExport, method: 'get', data: params,})
}

/**
 * 删除
 */
export async function deleteSurvey(params) {
    return request({url: survey, method: 'delete', data: params,})
}
/**
 * 清空
 */
export async function deleteSurveyEmptyAnswer(params) {
    return request({url: surveyEmptyAnswer, method: 'get', data: params,})
}


/**
 * 查找列表
 */
export async function findVotes(params) {
    return request({url: votes, method: 'get', data: params,})
}

export async function findAdminVotes(params) {
    return request({url: adminVotes, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function findVote(params) {
    return request({url: vote, method: 'get', data: params,})
}
/**
 * 创建
 */
export async function createVotes(params) {
    return request({url: votes, method: 'post', data: params,})
}
/**
 * 提交
 */
export async function submitVotesAnswer(params) {
    return request({url: votesAnswers, method: 'post', data: params,})
}
/**
 * 发送验证
 */
export async function sendVotesCaptcha(params) {
    return request({url: votesCaptcha, method: 'get', data: params,})
}/**
 * 验证
 */
export async function catchaVotesAnswerName(params) {
    return request({url: votesAnswerName, method: 'post', data: params,})
}
/**
 * 简单修改
 */
export async function updateVote(params) {
    return request({url: vote, method: 'put', data: params,})
}

/**
 * 删除
 */
export async function deleteVote(params) {
    return request({url: vote, method: 'delete', data: params,})
}
/**
 * 查询统计
 */
export async function findVotesStatistic(params) {
    return request({url: votesStatistic, method: 'get', data: params,})
}
/**
 * 查询统计
 */
export async function findVotesStatisticId(params) {
    return request({url: votesStatisticId, method: 'get', data: params,})
}
/**
 * 导出
 */
export async function exportVotes(params) {
    return request({url: votesExport, method: 'get', data: params,})
}
/**
 * 复制
 */
export async function findVotesCopy(params) {
    return request({url: votesCopy, method: 'get', data: params,})
}
/**
 * 清空
 */
export async function deleteVotesEmptyAnswer(params) {
    return request({url: votesEmptyAnswer, method: 'get', data: params,})
}
/**
 * 清空所有
 */
export async function deleteVotesEmpty(params) {
    return request({url: votesEmpty, method: 'delete', data: params,})
}


// WEBPACK FOOTER //
// ./src/services/questionnaire.js